

<div>
    <loading [isLoading]="this.twoLevelsSelectorService.isLoading | async"></loading>
    <polygon-selector-with-levels
    *ngIf="!isInitializing"
        #polygonSelector
        [hierarchyLevels]="hierarchyLevels"
        [autoLoad]="true"
        [isSelectionActive]="isPolygonSelectionWithevelsActive"
        [serviceType]="serviceType"
        [useExternalLayers]="true"
        (selectionChange)="onHierarchySelectionChange($event)">
    </polygon-selector-with-levels>

    <div class="main-zones-container">
        <div class="title-container">
            <span class="panel-title">Filtro Geográfico</span>
            <span class="panel-subtitle">(Regiones a Zonas)</span>
        </div>
        <div class="selected-zones">
            <div class="zone-semiCircle first-selection" [ngClass]="{'selected-zone': firstZone.isSelected, 'disabled': isInitializing}" (click)="firstZone.isSelected && resetToStart(true) && !isInitializing">
                {{ firstZone.name }}
            </div>
            <div class="zone-semiCircle second-selection" [ngClass]="{'selected-zone': secondZone.isSelected, 'disabled': isInitializing}" (click)="secondZone.isSelected && goBack() && !isInitializing">
                {{ secondZone.name }}
            </div>
        </div>
    </div>

</div>
